module.exports = __webpack_public_path__ + "static/media/kuibishan_plant.7da42515.webp";